import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../../components/AdminSidebar";
import "./admin.css";

export default function AdminStats() {
  const [stats, setStats] = useState({ pending: 0, approved: 0, rejected: 0, towerAdmins: null });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const role = localStorage.getItem("adminRole");
  const API = process.env.REACT_APP_API_URL;

  const loadStats = async () => {
    try {
      const res = await fetch(`${API}/api/admin/stats`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (!res.ok) {
        setError("Failed to load stats");
        return;
      }

      const data = await res.json();
      setStats(data);
    } catch (err) {
      setError("Server error while loading stats");
    }
  };

  useEffect(() => {
    loadStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="admin-layout">
      <AdminSidebar />

      <div className="admin-content">
        <h1>Dashboard Stats</h1>

        {error && <p className="admin-error">{error}</p>}

        <div className="stats-grid">
          <div className="stat-card stat-clickable" onClick={() => navigate("/admin/dashboard")}>
            <h2>{stats.pending}</h2>
            <p>Pending Requests</p>
          </div>

          <div className="stat-card stat-clickable" onClick={() => navigate("/admin/approved")}>
            <h2>{stats.approved}</h2>
            <p>Approved Residents</p>
          </div>

          <div className="stat-card stat-clickable" onClick={() => navigate("/admin/rejected")}>
            <h2>{stats.rejected}</h2>
            <p>Rejected Residents</p>
          </div>

          {role === "admin" && stats.towerAdmins !== null && (
            <div className="stat-card stat-clickable" onClick={() => navigate("/admin/tower-admins-all")}>
              <h2>{stats.towerAdmins}</h2>
              <p>Tower Admins</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}